export function equals(obj1, obj2) {
  if (obj1 && obj2) {
    return obj1 === obj2;
  }
  return !obj1 && !obj2;
}
export var addIfNotPresent = function (array, element) {
  if (array && element) {
    var present = array.some(function (el) {
      return el.id === element.id && el.value === element.value;
    });
    if (!present) {
      array.push(element);
    }
  }
};
export function getSeeAllURL(url, params) {
  var stringToAppend = '';
  for (var key in params) {
    if ((url === null || url === void 0 ? void 0 : url.indexOf(key)) === -1) {
      stringToAppend += "&".concat(key, "=").concat(params[key]);
    }
  }
  return url + stringToAppend;
}
export function getPageId(activitySearchStore) {
  if (activitySearchStore === undefined) {
    activitySearchStore = {};
  }
  return activitySearchStore.pageInfo ? activitySearchStore.pageInfo.pageId : 'SR';
}
export function getPageSize(activitySearchStore) {
  if (activitySearchStore === undefined) {
    activitySearchStore = {};
  }
  return (activitySearchStore === null || activitySearchStore === void 0 ? void 0 : activitySearchStore.paginationInfo) ? activitySearchStore.paginationInfo.pageSize : 0;
}
export function getFilteredObjectKeys(object, filterKey) {
  var keys = Object.keys(object);
  if (filterKey) {
    return keys.filter(function (key) {
      return key.includes(filterKey);
    });
  }
  return keys;
}
export var getGraphqlURL = function (headers, config) {
  var _a;
  var url;
  if ((_a = headers === null || headers === void 0 ? void 0 : headers.cookie) === null || _a === void 0 ? void 0 : _a.includes('lxpwastubmode=true')) {
    var protocol = headers.host.includes('localhost') || headers.host.includes('sandbox') ? 'http://' : 'https://';
    url = "".concat(protocol).concat(headers.host).concat(config.graphqlStubURL);
  } else {
    url = config.platform.bexApi.url;
  }
  return url;
};